export default function RiskManagementController(
  $q,
  $scope,
  bcpDataService,
  loaderService,
  userService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;
  vm.handleExpand = _handleExpand;

  _activate();

  // //////// METHODS //////////

  function _handleExpand() {
    if (vm.canExpand) {
      if (vm.hasData) {
        vm.isExpanded = !vm.isExpanded;
      } else {
        _refreshAssessmentThreats().then(() => {
          vm.isExpanded = true;
        });
      }
    }
  }

  function _activate() {
    _initEventListeners();
    _initPermissions();
    _initStatus(vm.status);
  }

  function _initPermissions() {
    vm.canExpand = vm.status !== 'Risk Management Not Started';
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshBCPRiskManagement', _refreshAssessmentThreats);
    $scope.$on('refreshOtherResourcesStatus', (event, opt) => {
      vm.status.otherResourcesStatus = opt.status;
      _initStatus(vm.status);
    });
    $scope.$on('refreshStatusesComplete', (event, status) => {
      _initStatus(status);
    });
  }

  /*
    TODO: Put this and the identical _initStatuses function from incomplete-assessment.controller.js into the same
    function call
  */
  function _initStatus(status) {
    vm.status = status;
    let departmentProceduresStatus = '';
    if (vm.status.departmentProceduresStatus !== 'No Recovery Procedures Set') {
      departmentProceduresStatus = 'complete';
    } else {
      departmentProceduresStatus = 'not started';
    }

    let departmentResourceStatus = '';
    if (vm.status.departmentResourceStatus === 'Department Resources Complete') {
      departmentResourceStatus = 'complete';
    } else if (
      vm.status.departmentResourceStatus !== 'Department Resources Complete'
      && vm.status.departmentResourceStatus !== 'No Department Resources Added'
    ) {
      departmentResourceStatus = 'in progress';
    } else {
      departmentResourceStatus = 'not started';
    }

    let facilitiesStatus = '';
    if (vm.status.facilitiesStatus === 'Facilities Info Complete') {
      facilitiesStatus = 'complete';
    } else {
      facilitiesStatus = 'not started';
    }

    let itCoreProceduresStatus = '';
    if (vm.status.itCoreProceduresStatus === 'IT/Core Procedures Complete') {
      itCoreProceduresStatus = 'complete';
    } else if (
      vm.status.itCoreProceduresStatus !== 'IT/Core Procedures Complete'
      && vm.status.itCoreProceduresStatus !== '0/3 IT/Core Procedures Complete'
    ) {
      itCoreProceduresStatus = 'in progress';
    } else {
      itCoreProceduresStatus = 'not started';
    }

    let schematicStatus = '';
    if (vm.status.schematicStatus !== '0 Schematics Added') {
      schematicStatus = 'complete';
    } else {
      schematicStatus = 'not started';
    }

    let workstationStatus = '';
    if (vm.status.workstationStatus !== '0 Workstations Added') {
      workstationStatus = 'complete';
    } else {
      workstationStatus = 'not started';
    }

    let serverStatus = '';
    if (vm.status.serverStatus !== '0 Servers Added') {
      serverStatus = 'complete';
    } else {
      serverStatus = 'not started';
    }

    let emergencyPlansStatus = '';
    if (vm.status.emergencyPlansStatus !== 'Emergency Plans Complete') {
      const emergencyPlansStatusArray = vm.status.emergencyPlansStatus.split('/');
      vm.completedEmergencyPlansCount = parseInt(emergencyPlansStatusArray[0], 10);
      if (vm.completedEmergencyPlansCount === 0) {
        emergencyPlansStatus = 'not started';
      } else {
        emergencyPlansStatus = 'in progress';
      }
    } else {
      emergencyPlansStatus = 'complete';
    }

    let pandemicPlansStatus = '';
    if (vm.status.pandemicPlansStatus === 'Pandemic Plans Complete') {
      pandemicPlansStatus = 'complete';
    } else {
      pandemicPlansStatus = 'not started';
    }

    let successionPlanningStatus = '';
    if (vm.status.successionPlanningStatus !== 'Succession Planning Complete') {
      const successionPlanningStatusArray = vm.status.successionPlanningStatus.split('/');
      vm.completedSuccessionPlanningCount = parseInt(successionPlanningStatusArray[0], 10);

      if (vm.completedSuccessionPlanningCount === 0) {
        successionPlanningStatus = 'not started';
        vm.successionPlanStatusColor = 'fc-navanta-charcoal-55';
      } else {
        successionPlanningStatus = 'in progress';
        vm.successionPlanStatusColor = 'fc-navanta-yellow-100';
      }
    } else {
      successionPlanningStatus = 'complete';
      vm.successionPlanStatusColor = 'fc-hula-skirt-green-100';
    }

    let healthResourceStatus = '';
    if (vm.status.healthResourceStatus !== 'No Health Resources Added') {
      healthResourceStatus = 'complete';
    } else {
      healthResourceStatus = 'not started';
    }

    let vendorResourcesStatus = '';
    if (vm.status.vendorResourcesStatus !== 'No Vendor Resources Added') {
      vendorResourcesStatus = 'complete';
    } else {
      vendorResourcesStatus = 'not started';
    }

    let otherResourcesStatus = '';
    if (vm.status.otherResourcesStatus !== 'No Other Resources Added') {
      otherResourcesStatus = 'complete';
    } else {
      otherResourcesStatus = 'not started';
    }
    if (
      departmentProceduresStatus === 'complete'
      && departmentResourceStatus === 'complete'
      && facilitiesStatus === 'complete'
      && itCoreProceduresStatus === 'complete'
      && (schematicStatus === 'complete' || !vm.includeSchematics)
      && (workstationStatus === 'complete' || !vm.includeSchematics)
      && (serverStatus === 'complete' || !vm.includeSchematics)
      && (emergencyPlansStatus === 'complete' || !vm.includeEmergencyPlan)
      && (pandemicPlansStatus === 'complete' || !vm.includePandemicPolicy)
      && successionPlanningStatus === 'complete'
      && (healthResourceStatus === 'complete' || !vm.includeKeyContacts)
      && (vendorResourcesStatus === 'complete' || !vm.includeKeyContacts)
      && (otherResourcesStatus === 'complete' || !vm.includeKeyContacts)
    ) {
      vm.riskManagementStatus = 'complete';
    } else if (
      departmentProceduresStatus === 'not started'
      && departmentResourceStatus === 'not started'
      && facilitiesStatus === 'not started'
      && itCoreProceduresStatus === 'not started'
      && schematicStatus === 'not started'
      && workstationStatus === 'not started'
      && serverStatus === 'not started'
      && emergencyPlansStatus === 'not started'
      && pandemicPlansStatus === 'not started'
      && successionPlanningStatus === 'not started'
      && healthResourceStatus === 'not started'
      && vendorResourcesStatus === 'not started'
      && otherResourcesStatus === 'not started'
    ) {
      vm.riskManagementStatus = 'not started';
    } else {
      vm.riskManagementStatus = 'in progress';
    }

    const hardwareAndSchematicsText = vm.includeSchematics
      ? `${vm.status.schematicStatus}<br>
      ${vm.status.workstationStatus}<br>
      ${vm.status.serverStatus}<br>`
      : '';

    const emergencyPlanText = vm.includeEmergencyPlan
      ? `${vm.status.emergencyPlansStatus}<br>`
      : '';

    const pandemicPolicyText = vm.includePandemicPolicy
      ? `${vm.status.pandemicPlansStatus}<br>`
      : '';

    const keyContactsText = vm.includeKeyContacts
      ? `${vm.status.healthResourceStatus}<br>
      ${vm.status.vendorResourcesStatus}<br>
      ${vm.status.otherResourcesStatus}<br>`
      : '';

    vm.riskManagementStatusText = `${vm.status.departmentProceduresStatus}<br>
      ${vm.status.departmentResourceStatus}<br>
      ${vm.status.facilitiesStatus}<br>
      ${vm.status.itCoreProceduresStatus}<br>
      ${hardwareAndSchematicsText}
      ${emergencyPlanText}
      ${pandemicPolicyText}
      ${vm.status.successionPlanningStatus}<br>
      ${keyContactsText}
    `;
  }

  function _refreshAssessmentThreats() {
    return $q.all([
      _refreshThreatOptions(),
      _refreshThreats()
    ]);
  }

  function _refreshThreats() {
    loaderService.showViewLoader = true;
    return bcpDataService.getThreats(vm.assessmentId)
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.assessmentThreats = response.data.result;
        vm.hasData = true;
      });
  }

  function _refreshThreatOptions() {
    if (vm.threatOptions) {
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return bcpDataService.getThreatOptions()
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.threatOptions = response.data;
      });
  }
}

RiskManagementController.$inject = [
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'userService'
];
